<template>
  <div>
    <div v-show="isReady" class="card">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
              <h3 class="card-label">{{ $t('bundle.list') }}</h3>
          </div>

        <div class="card-toolbar">
          <button v-if="$can('bundle_create')" class="btn btn-sm btn-primary  my-1" @click="$router.push({ name: 'bundle-create-path' })">{{ $t('bundle.new') }}</button>
        </div>
      </div>
      <div class="card-body">
          <div class="row">
              <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_bundle">
                  <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th class="min-w-100px">{{ $t('bundle.image')}}</th>
                    <th class="min-w-100px">{{ $t('bundle.title')}}</th>
                    <th class="min-w-100px">{{ $t('bundle.description')}}</th>
                    <th class="min-w-100px">{{ $t('bundle.online')}}</th>
                    <th class="min-w-100px">{{ $t('bundle.bundle_price')}}</th>
                    <th class="min-w-100px">{{ $t('bundle.product_count')}}</th>
                    <th class="min-w-100px">{{ $t('action') }}</th>
                  </tr>
                  </thead>
              </table>
          </div>
      </div>
    </div>

    <div v-show="!isReady" class="row loader text-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import {mapActions, mapGetters} from "vuex";
import {nextTick} from "vue";
import Loader from "@/components/Loader.vue";

export default {
    components: { Loader },
    data(){
        return{
          formDeleteData: {
              id: null,
              row: null
          },
          table: null,
          isReady: false
        }
    },

    watch: {
        '$i18n.locale' : function(value){
            if(value && this.table){
                this.$nextTick(() => {
                    this.fetchDatas()
                })
            }
        }
    },

    computed: {
      ...mapGetters('shop', ['getDefaultCurrency']),
    },

    mounted(){
      this.isReady = false
      this.loadPermissions()
      Promise.all([
          this.getCurrency()
      ])
      this.fetchDatas()
      this.initSelect2()

        $(".kt_select2").select2()

        this.isReady = true

      $(document).on("click", "#kt_datatable_bundle .edit_btn", (e) => {
        let id = e.target.getAttribute('data-id')
        this.$router.push({ name: 'bundle-edit-path', params: { id } })
      });

      $(document).on("click", "#kt_datatable_bundle .btn_change_online", (e) => {
        e.stopImmediatePropagation()
        const id = e.target.getAttribute('data-id')
        this.updateBundleOnlineData(id)
      });

      $(document).on("click", "#kt_datatable_bundle .delete_btn", (e) => {
        this.formDeleteData.id = e.target.getAttribute('data-id')
        this.formDeleteData.row = e.target.getAttribute('data-row')
        this.deleteBundleRow()
      });
    },

    methods: {
        ...mapActions('permission', [
            'loadPermissions'
        ]),

        ...mapActions('bundle', [
            'deleteBundle',
            'setBundleOnline'
        ]),

      ...mapActions('shop', ['getCurrency']),

        initSelect2() {
            KTApp.initSelect2()
            $(".kt_select2").select2()
        },

        fetchDatas(){
            const AUTH_TOKEN = Ls.get('auth.token')

            this.table = $("#kt_datatable_bundle").DataTable({
                destroy: true,
                responsive: !0,
                searchDelay: 500,
                processing: !0,
                serverSide: !0,
                pageLength:Ls.get('pageLength') ?? 10,
                lengthMenu: [5, 10, 25, 50, 75, 100 ],
                order: [[ 1, 'asc']],
                ajax: {
                    url: BASE_URL + "/bundle/datatables",
                    type: "GET",
                    beforeSend: function (request) {
                        request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
                    }
                },
                columns: [

                    { data: "file" },{ data: "title" }, { data: "description" },{ data: "online" }, { data: "price" }, { data: "product_count" }, { data: "actions", responsivePriority: -1 }],
                columnDefs: [
                    {
                        targets: -7,
                        orderable:false,
                        searchable:false,
                        className: "dt-center clickable" ,
                        render: function (t, a, e, l) {
                            return '<img id="'+ e.id +'" src="'+ e.file_url +'"  style="width: 50px; height: 50px;" />';
                        },
                    },

                    {
                        targets: -6,
                        className: "dt-center clickable" ,
                        render: function (t, a, e, l) {
                            return '<span data-id="'+ e.id +'">' + t + "</span>";
                        },
                    },

                    {
                        targets: -5,
                        className: "dt-center clickable" ,
                        render: function (t, a, e, l) {
                            // La description est du HTML (éditeur riche) : on retire les balises
                            // avant de tronquer, pour ne pas couper au milieu d'une balise.
                            const plainText = (t || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
                            const truncated = plainText.length > 40 ? plainText.substring(0, 40) + '…' : plainText
                            const escaped = truncated.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                            const escapedTitle = plainText.replace(/"/g, '&quot;')
                            return '<span data-id="'+ e.id +'" title="' + escapedTitle + '">' + escaped + "</span>";
                        },
                    },

                    {
                        targets: -4,
                        orderable:false,
                        searchable:false,
                        render:  (t, a, e, l) => {
                          if (this.$can('bundle_update')) {
                            const checked = t ? "checked" : "";
                            return '<span class="form-check form-switch form-check-custom form-check-solid visible btn_change_online" data-id="' + e.id + '"><label><input type="checkbox" ' + checked + ' id="' + e.id + '" class="form-check-input online h-20px w-30px" data-id="' + e.id + '" /><span></span></label></span>';
                          }
                        },
                    },
                    {
                      targets: -3,
                      orderable:false,
                      searchable:false,
                      className: "dt-center clickable",
                      render:  (t, a, e, l) => {
                        return '<span data-id="'+ e.id +'">' + this.$formatLocalAmount(t) + ' ' + this.getDefaultCurrency + "</span>";
                      },
                    },
                    {
                      targets: -2,
                      orderable:false,
                      searchable:false,
                      className: "dt-center clickable",
                      render:  (t, a, e, l) => {
                        return '<span data-id="'+ e.id +'">' + t + "</span>";
                      },
                    },

                    {
                        width: "20%",
                        targets: -1,
                        "className": "dt-center",
                        title: "actions",
                        orderable: !1,
                        render: (t, a, e, l) => {
                            let render=""
                          if(this.$can('bundle_update')  ){
                            render+='<a href="javascript:;" data-parents="'+ e.parent_id +'" data-image="'+ e.image_url +'"   data-id="'+ e.id +'" data-name="'+ e.name +'" data-image="'+e.image_url +'" data-online="'+e.online +'"  class="btn btn-sm btn-clean btn-icon   edit_btn" title="'+ i18n.global.t('button.edit') +'"><i data-parents="'+ e.parent_id +'"  data-image="'+ e.image_url +'"  data-id="'+ e.id +'" data-name="'+ e.name +'" data-image="'+e.image_url +'"  data-online="'+e.online +'"     class="la la-edit fs-2"></i></a>'

                          }
                          if(this.$can('bundle_delete')  ){
                            render += '<a href="javascript:;" data-row="'+ l.row +'" data-id="'+ e.id +'" class="btn btn-sm btn-clean btn-icon delete_btn" title="'+ i18n.global.t('button.delete') +'"><i data-row="'+ l.row +'" data-id="'+ e.id +'" class="la la-trash fs-2"></i></a>'

                          }

                            return render
                        },
                    },
                ],
                language: {
                    url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
                }
            });
        },

        loadBundle(bundle){
            this.table.ajax.reload()
        },

        async deleteBundleRow() {
            let response = {}
            Swal.fire({
                title: i18n.global.t('swal.bundle'),
                text: i18n.global.t('swal.text'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: i18n.global.t('swal.yes'),
                cancelButtonText: i18n.global.t('swal.no'),
            }).then(async (result) => {
                if (result.value) {
                    try {
                        response = await this.deleteBundle(this.formDeleteData.id)
                        window.toastr['success'](i18n.global.t("notification.bundle_deleted"))
                        this.table.ajax.reload()
                    } catch (e) {
                        if (response && response.data) {
                            window.toastr['error'](response.data.error)
                            return true
                        }
                    }
                }
            });
        },

      updateBundleOnlineData(id) {
        try {
          this.setBundleOnline(id)
          window.toastr['success'](i18n.global.t("notification.bundle_online"))
        } catch (e) {
          window.toastr['success'](i18n.global.t('notification.promotion.update_status_error'))
        }
      },
    }
}
</script>

<style scoped>
.badge {
    display: none !important;
    align-items: center;
}

.badge-light-danger {
    color: #f1416c;
    background-color: #fff5f8;
    padding: 15px !important;
    text-align: center !important;
}</style>
